import React from "react";
import { Form as FinalForm } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import { FormContext } from "../context";

const Form = ({
  children,
  initialValues = {},
  cancelBtn = {
    label: "Cancel",
    onClick: null,
  },
  submitBtn = {
    label: "Submit",
    onClick: null,
  },
  fullWidthButtons = false,
  requesting = false,
  disabled = false,
  extraBtn = null,
}) => {
  const onHandleSubmit = (values) => {
    if (submitBtn.onClick) submitBtn.onClick(values);
  };

  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={onHandleSubmit}
      mutators={{
        ...arrayMutators,
      }}
      keepDirtyOnReinitialize
      render={({ handleSubmit, form }) => {
        const {
          mutators: { push, pop, move, update },
          reset,
          change,
          resetFieldState,
          getState, // this is now accessible
          blur,
        } = form;
        return (
          <form onSubmit={handleSubmit} noValidate>
            <FormContext.Provider
              value={{
                push,
                pop,
                move,
                update,
                reset,
                change,
                resetFieldState,
                getState,
                blur,
              }}
            >
              {children}
            </FormContext.Provider>
            <div
              className={`flex justify-content-end gap-2 mt-4 w-full ${
                fullWidthButtons ? "flex-wrap" : ""
              }`}
            >
              {cancelBtn.onClick && !disabled && (
                <Button
                  loading={requesting}
                  type="button"
                  outlined
                  disabled={cancelBtn.disabled}
                  className={`${fullWidthButtons ? "w-full" : "min-w-8rem"}`}
                  onClick={(event) => {
                    // Cancel drops what was typed. Many screens keep this
                    // form on the page and only switch it to read-only, so
                    // the typed values stayed there for the next Edit and
                    // save to send. A plain reset() keeps dirty values too
                    // while keepDirtyOnReinitialize is on, so it is off for
                    // the reset. Reset first: the handler may unmount the form.
                    form.setConfig("keepDirtyOnReinitialize", false);
                    form.reset();
                    form.setConfig("keepDirtyOnReinitialize", true);
                    cancelBtn.onClick(event);
                  }}
                >
                  <div className="gap-2 flex justify-content-center w-full">
                    {cancelBtn.label}
                  </div>
                </Button>
              )}
              {(submitBtn.onClick && !disabled && (
                <Button
                  loading={requesting}
                  type="submit"
                  disabled={submitBtn.disabled}
                  className={`${fullWidthButtons ? "w-full" : "min-w-8rem"}`}
                >
                  {(!requesting && (
                    <div className="gap-2 flex justify-content-center w-full">
                      {submitBtn.label}
                      {(submitBtn.icon && (
                        <i className={`pi ${submitBtn.icon}`}></i>
                      )) ||
                        null}
                    </div>
                  )) ||
                    null}
                </Button>
              )) ||
                null}
              {extraBtn && !disabled && (
                <Button
                  type="button"
                  className={`${fullWidthButtons ? "w-full" : "min-w-8rem"}`}
                  outlined={Boolean(extraBtn.outlined)}
                  onClick={() => {
                    const { invalid, values } = form.getState();
                    if (extraBtn.shouldValidate) {
                      if (invalid) {
                        Object.keys(values).forEach((element) => {
                          form.blur(element);
                        });
                      } else {
                        extraBtn.onClick(values);
                      }
                    } else {
                      extraBtn.onClick(values);
                    }
                  }}
                >
                  <div className="gap-2 flex justify-content-center w-full">
                    {extraBtn.label}
                    {(extraBtn.icon && (
                      <i className={`pi ${extraBtn.icon}`}></i>
                    )) ||
                      null}
                  </div>
                </Button>
              )}
            </div>
          </form>
        );
      }}
    />
  );
};

Form.propTypes = {
  cancelBtn: PropTypes.object,
  children: PropTypes.node,
  fullWidthButtons: PropTypes.bool,
  initialValues: PropTypes.object,
  requesting: PropTypes.bool,
  submitBtn: PropTypes.object,
  extraBtn: PropTypes.object,
};

export default Form;
